var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import LottieButton from './LottieButton';
import { styled, ImgThemeConsumer } from '../theme/ThemeHelpers';
import { getAnimation } from '../theme/Animations';
import { getColor } from '../helpers/ColorHelpers';
import { belowBreakpointOrEqual } from '..';
import { appendPx } from '../theme/DefaultTheme';
export var DimmerContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    display: table;\n    height: calc(100% + 5px);\n    width: 100%;\n    top: -5px;\n    left: 0;\n    transform: scale(", ");\n    z-index:2147483637;\n    cursor: default;\n    vertical-align: middle;\n    animation: ", " ", "s;\n"], ["\n    position: fixed;\n    display: table;\n    height: calc(100% + 5px);\n    width: 100%;\n    top: -5px;\n    left: 0;\n    transform: scale(", ");\n    z-index:2147483637;\n    cursor: default;\n    vertical-align: middle;\n    animation: ", " ", "s;\n"])), function (props) { return props.active ? 1 : 0; }, function (props) { return !props.initial && getAnimation(props.theme.dimmer[props.active ? "start" : "end"]); }, function (props) { return props.theme.dimmer.animationDuration; });
export var DimmerContentContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: table-cell;\n    background: ", ";\n    border-top:5px solid ", ";\n    text-align: center;\n    vertical-align: middle;\n    width: 100%;\n"], ["\n    display: table-cell;\n    background: ", ";\n    border-top:5px solid ", ";\n    text-align: center;\n    vertical-align: middle;\n    width: 100%;\n"])), function (props) { return props.light ? "rgba(255,255,255,0.0)" : getColor(props, props.theme.dimmer.backgroundColor); }, function (props) { return props.light ? "rgba(255,255,255,0.0)" : getColor(props, props.theme.colors.accent); });
var IconContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: fixed;\n    top: ", ";\n    right: ", ";\n    transform: scale(", ");\n    cursor: pointer;\n    z-index:50000;\n"], ["\n    position: fixed;\n    top: ", ";\n    right: ", ";\n    transform: scale(", ");\n    cursor: pointer;\n    z-index:50000;\n"])), function (props) { return appendPx(props.mobile ? 14 : 10); }, function (props) { return appendPx(props.mobile ? -2 : 10); }, function (props) { return props.mobile ? 0.7 : 1; });
var Dimmer = /** @class */ (function (_super) {
    __extends(Dimmer, _super);
    function Dimmer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            active: props.active ? props.active : false,
            initial: true,
        };
        return _this;
    }
    Dimmer.prototype.componentDidUpdate = function (prevProps, prevState) {
        var active = this.props.active;
        if (prevState.active !== active) {
            this.setState({ active: active ? active : false, initial: false });
        }
    };
    Dimmer.prototype.render = function () {
        var _this = this;
        var _a = this.state, active = _a.active, initial = _a.initial;
        var _b = this.props, onClick = _b.onClick, button = _b.button;
        return (React.createElement(ImgThemeConsumer, null, function (theme) {
            var mobile = belowBreakpointOrEqual({ theme: theme }, "mobile");
            return (React.createElement(DimmerContainer, { active: active, initial: initial, onClick: button ? undefined : onClick },
                button &&
                    React.createElement(IconContainer, { onClick: onClick, mobile: mobile },
                        React.createElement(LottieButton, { kind: "primary", lottie: { url: "./images/lottiIcons/eyeBlinking.json", behaviour: "Loop", padding: "0px", speed: 0.7 }, size: "default" })),
                React.createElement(DimmerContentContainer, null, _this.props.children)));
        }));
    };
    return Dimmer;
}(React.PureComponent));
export default Dimmer;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Dimmer.js.map